import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewEncapsulation,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "kzn-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./dialog.component.html",
  styleUrl: "./dialog.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent {
  @Input({ required: true }) title!: string;
  @Input() isActionDisabled: boolean = false;
  @Input() isCancelDisabled: boolean = false;
  @Input({ required: true }) actionLabel!: string;
  @Input() isActionInProgress: boolean = false;
  @Input() isSecondaryActionInProgress: boolean = false;
  @Input() actionColor: string = 'primary';
  @Input() showReset: boolean = false;
  @Input() showSecondaryAction: boolean = true;
  @Input() secondaryActionLabel: string = 'Cancel';
  @Input() secondaryActionClass: string = 'decline-btn';
  @Input() resetLabel: string = 'Reset';
  @ContentChildren("content") content!: QueryList<HTMLElement>;
  @Output() actionFired = new EventEmitter();
  @Output() secondaryActionFired = new EventEmitter();
  @Output() onReset = new EventEmitter();

  constructor(private _dialogRef: MatDialogRef<unknown>) {
    this._dialogRef.disableClose = true;
  }

  saveData() {
    this.actionFired.emit();
  }

  secondaryAction() {
    this.secondaryActionFired.emit();
  }

  reset() {
    this.onReset.emit();
  }
}
